module.exports = __webpack_public_path__ + "img/6.cb448289.png";